import { render, staticRenderFns } from "./VcDateInput.vue?vue&type=template&id=712578c6&scoped=true"
import script from "./VcDateInput.vue?vue&type=script&lang=js"
export * from "./VcDateInput.vue?vue&type=script&lang=js"
import style0 from "./VcDateInput.vue?vue&type=style&index=0&id=712578c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712578c6",
  null
  
)

export default component.exports